// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CopyrightCircleOutlinedSvg from "@fishx/icons-svg/es/asn/CopyrightCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var CopyrightCircleOutlined = function CopyrightCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CopyrightCircleOutlinedSvg
  }));
};

CopyrightCircleOutlined.displayName = 'CopyrightCircleOutlined';
export default React.forwardRef(CopyrightCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CopyrightCircleOutlined.js
// module id = 2329
// module chunks = 0